import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-ms-blocked-print-confirm",
	templateUrl: "./ms-blocked-print-confirm.component.html",
	styleUrls: ["./ms-blocked-print-confirm.component.css"],
})
export class MsBlockedPrintConfirmComponent implements OnInit {
	constructor(private ref: DynamicDialogRef) {}

	ngOnInit(): void {}

	////////////////////////////////////
	// Data
	////////////////////////////////////

	SelectOptionID: number = 0;
	SelectOptionList: any = [
		{
			ID: 0,
			Desc: "Blocked Visitors Only",
		},
		{
			ID: 1,
			Desc: "Blocked Visitors and Allowed Offenders",
		},
		{
			ID: 2,
			Desc: "Unblocked Offenders Only",
		},
	];

	OutputTypeID: number = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	////////////////////////////////////

	////////////////////////////////////
	// Buttons
	////////////////////////////////////
	onClose() {
		this.ref.close({
			Success: false,
			OutputTypeID: -1,
			SelectOptionID: -1,
		});
	}
	onContinue() {
		this.ref.close({
			Success: true,
			OutputTypeID: this.OutputTypeID,
			SelectOptionID: this.SelectOptionID,
		});
	}
}
